// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-no-important */
.ToIeQ65RCFeonz {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 40px;
}
@media only screen and (max-width: 600px) {
  .ToIeQ65RCFeonz {
    display: block;
    padding-top: 0;
  }
}
.ToIeQ65RCFeonz .Y_oqK4iczxU45_ {
  width: 100%;
  min-width: 288px;
  max-width: 825px;
}
@media only screen and (max-width: 600px) {
  .ToIeQ65RCFeonz .Y_oqK4iczxU45_ {
    width: auto;
    margin-left: 16px;
  }
}
.Z8LG2rNfPsOGEp {
  padding-top: 40px;
}
._hOWPJUpqUcsGv {
  flex: 1 1 auto;
  min-height: calc(100vh - 40px);
  padding-bottom: 32px;
}
.Xr71Q3jIC2CBEp {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Md4HNL3_G1jIgz:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224) !important;
  text-decoration: none;
}
.wkVPDtDtbW7KOV {
  font-weight: bold;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ToIeQ65RCFeonz`,
	"galleryContainer": `Y_oqK4iczxU45_`,
	"containerLoggedOut": `Z8LG2rNfPsOGEp`,
	"spinnerContainer": `_hOWPJUpqUcsGv`,
	"spinner": `Xr71Q3jIC2CBEp`,
	"navigationLink": `Md4HNL3_G1jIgz`,
	"boldNavigationLink": `wkVPDtDtbW7KOV`
};
export default ___CSS_LOADER_EXPORT___;
